import React from "react";

function Footer() {
  return (
    <div className="py-10">
      <div className="h-[1px] w-full bg-gray-700"></div>
      <div className="flex flex-col mt-5 items-center justify-center opacity-70">
        <h1 className="text-white">Designed & Developed by</h1>
        <p className="text-white text-xs">Sai Varun Reddy Gangasani</p>
      </div>
    </div>
  );
}

export default Footer;
